import { ListItem, Text, UnorderedList, VStack } from '@cdl/heartbeat-react';
import { InfoModal } from './InfoModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  uncertainWaveCount: number;
  microvoltedWaveCount: number;
}

export const IncorrectOptionalNoiseTagModal = ({
  isOpen,
  onClose,
  uncertainWaveCount,
  microvoltedWaveCount,
}: Props) => {
  return (
    <InfoModal
      isOpen={isOpen}
      title={'⚠️ Incorrect subtag'}
      onClose={onClose}
      closeButtonLabel='Go back'
      isBlocking
      withDashedBorder
    >
      <VStack align='start'>
        <Text>You have annotated with incorrect subtags for:</Text>
        <UnorderedList pl='l'>
          {uncertainWaveCount > 0 && (
            <ListItem>
              {uncertainWaveCount} uncertain wave(s), you should select
              <Text as='b'> exactly 1 </Text> subtag
            </ListItem>
          )}
          {microvoltedWaveCount > 0 && (
            <ListItem>
              {microvoltedWaveCount} microvolted wave(s), you should select at
              <Text as='b'> least 1 </Text> subtag
            </ListItem>
          )}
        </UnorderedList>
        <Text>
          Please correct the subtag selection(s) before saving the delineation.
        </Text>
      </VStack>
    </InfoModal>
  );
};
